module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAABH0lEQVR4AWOgC+DbcEBn80qm9ScY1p8igCDAeMuSeXuDOTYcQZI7w7DuPAitP41Fg/qmtY27Mtk2HIOr5t5wyHjzEqC1rOuPo+iBAMPNS/t2J3BtOAwWPcu+/njujsprh9RPHDD22zaBcf1ZhB4IUNu0tm5XDtv6Y0AJ5vWnpTfu2LHf4f9xBiACGsS74QgTmg36m5fN3BPOvuEow7qLPtsmpuyor9mV++GI0JPDcnHbW4Bs7c2rsNgA8sO6c2qb1kVubzfdsihhe3P49k6Dzctyd1QIb9iLzw+iG3dLb9zmuHWW1Zb59ltmi4BUn0ULpTWNu7KQQuks8/pTWptXW2+ZJ7dpCzBw8cYDAp0DKz2HJR74N+zX27yCqJgelAAAA4vqI0Z7/rQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/KZ.png
// module id = 1188
// module chunks = 0